import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const STATUS_DOT = {
  green: 'bg-emerald-400',
  yellow: 'bg-purple-400',
  red: 'bg-red-400',
};

const STATUS_BG = {
  green: 'border-emerald-500/20',
  yellow: 'border-amber-500/20',
  red: 'border-red-500/20',
};

export const IntegrationHealthWidget = () => {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/integrations/health`);
        setIntegrations(res.data.integrations || []);
      } catch {
        // silent fail on widget
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return null;

  const greenCount = integrations.filter(i => i.status === 'green').length;
  const total = integrations.length;

  return (
    <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6" data-testid="integration-health-widget">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Integration Health</h3>
        <span className="text-xs text-slate-400">{greenCount}/{total} healthy</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {integrations.map((intg) => (
          <div
            key={intg.service}
            className={`flex items-center gap-3 p-3 bg-slate-800/50 rounded-lg border ${STATUS_BG[intg.status] || STATUS_BG.red}`}
            data-testid={`integration-${intg.service.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${STATUS_DOT[intg.status] || STATUS_DOT.red}`}></span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-white truncate">{intg.service}</p>
              <p className="text-xs text-slate-400 truncate">
                {intg.details || intg.error || 'No details'}
              </p>
              {intg.last_sync && (
                <p className="text-xs text-slate-500 mt-0.5">
                  Synced: {new Date(intg.last_sync).toLocaleDateString()}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationHealthWidget;
